"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionButton = void 0;
var react_1 = __importStar(require("react"));
var design_system_popovers_1 = require("@contrast-security-inc/design-system-popovers");
var design_system_buttons_1 = require("@contrast-security-inc/design-system-buttons");
var css_1 = require("@emotion/css");
var design_system_layouts_1 = require("@contrast-security-inc/design-system-layouts");
var design_system_typography_1 = require("@contrast-security-inc/design-system-typography");
var design_system_foundations_1 = require("@contrast-security-inc/design-system-foundations");
var actionCss = function (disabled, selectedTheme) { return (0, css_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  cursor: pointer;\n  gap: 2px;\n  ", "\n"], ["\n  cursor: pointer;\n  gap: 2px;\n  ", "\n"])), !disabled
    ? ":focus-visible, :hover {\n      span, button, svg {\n        color: ".concat((0, design_system_foundations_1.getThemeValue)(selectedTheme, { light: design_system_foundations_1.theme.color.neutral100, dark: design_system_foundations_1.theme.color.neutral30 }), ";\n        fill: ").concat((0, design_system_foundations_1.getThemeValue)(selectedTheme, { light: design_system_foundations_1.theme.color.neutral100, dark: design_system_foundations_1.theme.color.neutral30 }), ";\n        stroke: ").concat((0, design_system_foundations_1.getThemeValue)(selectedTheme, { light: design_system_foundations_1.theme.color.neutral100, dark: design_system_foundations_1.theme.color.neutral30 }), ";\n      }\n    }")
    : "\n      cursor: not-allowed;\n      span {\n        opacity: 0.5;\n      }\n    "); };
var metadataTextColor = function (selectedTheme) { return (selectedTheme === 'dark' ? 'neutral50' : 'neutral80'); };
exports.ActionButton = (0, react_1.forwardRef)(function (_a, ref) {
    var IconButtonProps = _a.IconButtonProps, TooltipProps = _a.TooltipProps, metadata = _a.metadata, onClick = _a.onClick, className = _a.className, isDisabled = _a.isDisabled, 
    // Popover Aria props should be passed to button
    ariaExpanded = _a["aria-expanded"], ariaHasPopup = _a["aria-haspopup"], ariaControls = _a["aria-controls"], rest = __rest(_a, ["IconButtonProps", "TooltipProps", "metadata", "onClick", "className", "isDisabled", 'aria-expanded', 'aria-haspopup', 'aria-controls']);
    var selectedTheme = (0, design_system_foundations_1.useThemeContext)().selectedTheme;
    var tooltipAndButton = (react_1.default.createElement(design_system_popovers_1.Tooltip, __assign({}, TooltipProps, { enabled: TooltipProps.enabled !== false, size: "sm", ref: ref }),
        react_1.default.createElement(design_system_buttons_1.IconButton, __assign({ isDisabled: isDisabled }, (!metadata ? __assign({ onClick: onClick, className: className }, rest) : {}), IconButtonProps, { "aria-expanded": ariaExpanded, "aria-haspopup": ariaHasPopup, "aria-controls": ariaControls }))));
    return metadata ? (react_1.default.createElement(design_system_layouts_1.Stack, __assign({}, rest, { className: (0, css_1.cx)(actionCss(!!isDisabled, selectedTheme), className, 'ds-action-button'), 
        // if there's metadata pass the interactive props to the Stack
        onClick: !isDisabled ? onClick : undefined, alignItems: "center", ref: ref }),
        metadata && (react_1.default.createElement(design_system_typography_1.Text, { font: "metadata", color: metadataTextColor(selectedTheme) }, metadata)),
        tooltipAndButton)) : (tooltipAndButton);
});
exports.ActionButton.displayName = 'ActionButton';
var templateObject_1;
